import React from 'react';
import Icon from '../../../components/AppIcon';

const DepartmentPerformanceGrid = ({ departments, onDrillDown }) => {
  const getScoreColor = (score) => {
    if (score >= 90) return 'text-success';
    if (score >= 75) return 'text-warning';
    return 'text-error';
  };

  const getScoreBg = (score) => {
    if (score >= 90) return 'bg-success/10';
    if (score >= 75) return 'bg-warning/10';
    return 'bg-error/10';
  };

  const getScoreBadge = (score) => {
    if (score >= 90) return { bg: 'bg-success/10', text: 'text-success', label: 'Compliant' };
    if (score >= 75) return { bg: 'bg-warning/10', text: 'text-warning', label: 'Warning' };
    return { bg: 'bg-error/10', text: 'text-error', label: 'Critical' };
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="font-heading font-semibold text-lg text-foreground mb-1">
            Department Performance Matrix
          </h3>
          <p className="caption text-sm text-muted-foreground">
            Click any department to view detailed analytics and compliance reports
          </p>
        </div>
        <button
          onClick={() => onDrillDown?.('/compliance-overview')}
          className="flex items-center gap-2 text-sm text-primary hover:underline"
        >
          <span>View All Departments</span>
          <Icon name="ArrowRight" size={16} color="var(--color-primary)" />
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {departments?.map((dept, index) => {
          const badge = getScoreBadge(dept?.score);
          return (
            <div
              key={index}
              onClick={() => onDrillDown?.('/compliance-overview')}
              className="bg-muted border border-border rounded-lg p-5 transition-smooth hover:shadow-md cursor-pointer hover-lift"
            >
              <div className="flex items-start justify-between mb-3">
                <div>
                  <h4 className="font-medium text-foreground mb-1">{dept?.name}</h4>
                  <p className="text-xs text-muted-foreground">{dept?.manager}</p>
                </div>
                <div className={`${getScoreBg(dept?.score)} px-3 py-1 rounded-md`}>
                  <span className={`text-lg font-bold ${getScoreColor(dept?.score)}`}>
                    {dept?.score}%
                  </span>
                </div>
              </div>
              <div className="flex items-center justify-between mb-2">
                <span className="text-xs text-muted-foreground">Employees</span>
                <span className="text-sm font-medium text-foreground">{dept?.employees}</span>
              </div>
              <div className="flex items-center justify-between mb-3">
                <span className="text-xs text-muted-foreground">Violations</span>
                <span className={`text-sm font-medium ${dept?.violations > 0 ? 'text-error' : 'text-success'}`}>
                  {dept?.violations}
                </span>
              </div>
              <div className={`${badge?.bg} ${badge?.text} px-3 py-1 rounded-md text-center text-xs font-medium`}>
                {badge?.label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DepartmentPerformanceGrid;